<script setup lang="ts">
import { useI18nTypes } from '@/composables'

withDefaults(
  defineProps<{
    open: boolean
    message?: string
    position?: 'top' | 'center'
  }>(),
  {
    message: 'receive.doneCopy',
    position: 'center',
  },
)

const { t } = useI18nTypes()
</script>

<template>
  <Transition name="fade">
    <div v-if="open" class="modal" :class="position">
      <div class="inner">{{ t(message) }}</div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@import 'wepin-vue-component/src/styles/typeface.module.scss';
.modal {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
  z-index: 999;
  .inner {
    @include typeface('Paragraph_14_r');
    background-color: rgba(0, 0, 0, 0.8);
    padding: 15px;
    border-radius: 5px;
    color: var(--grey_fff);
    white-space: nowrap;
  }
}

.modal.top {
  top: 20%;
  position: fixed;
}
</style>
